import { useTranslation } from 'react-i18next'
import { BriefingRequiredNextBanner } from '@/shared/briefing'
import type { LvdBriefingStep } from '../../utils/lvdLegislationBriefing'
import { LVD_BRIEFING_ID_PREFIX } from './constants'
import { toV2LvdBriefingStep } from './toV2LvdBriefingStep'

export function V2LvdRequiredNextBanner({
  firstIncompleteStep,
}: {
  firstIncompleteStep: LvdBriefingStep | null
}) {
  const { t } = useTranslation('common')

  const firstIncompleteStepWithLabels =
    firstIncompleteStep != null ? toV2LvdBriefingStep(firstIncompleteStep, t) : null

  let incompleteMessage = ''
  if (firstIncompleteStepWithLabels != null) {
    incompleteMessage = t(
      'v2.pages.products.detail.lvdBriefing.requiredNext.stepMessage',
      {
        stepTitle: firstIncompleteStepWithLabels.title,
      }
    )
    if (firstIncompleteStep?.key === 'euDeclaration') {
      incompleteMessage = t(
        'v2.pages.products.detail.lvdBriefing.requiredNext.blockedByDeclaration',
        { stepTitle: firstIncompleteStepWithLabels.title }
      )
    }
  }

  const goToStepLabel =
    firstIncompleteStepWithLabels != null
      ? t('v2.pages.products.detail.lvdBriefing.requiredNext.goToStep', {
          stepTitle: firstIncompleteStepWithLabels.title,
        })
      : ''

  return (
    <BriefingRequiredNextBanner
      idPrefix={LVD_BRIEFING_ID_PREFIX}
      title={t('v2.pages.products.detail.lvdBriefing.requiredNext.title')}
      allCompleteMessage={t(
        'v2.pages.products.detail.lvdBriefing.requiredNext.allComplete'
      )}
      incompleteMessage={incompleteMessage}
      goToStepLabel={goToStepLabel}
      firstIncompleteStep={firstIncompleteStepWithLabels}
    />
  )
}
